import {validAuthReturn} from '../../shared/authContinuation';

export function authReturn() {
  return validAuthReturn(new URLSearchParams(window.location.search).get('returnTo'))
    || validAuthReturn(sessionStorage.getItem('pabs-client-return'))
    || validAuthReturn(sessionStorage.getItem('pabs-auth-return'));
}
export function rememberAuthReturn(value) {
  const target = validAuthReturn(value);
  if (target) sessionStorage.setItem('pabs-auth-return', target);
  return target;
}
export function authDestination(path, target = authReturn()) {
  return target ? `${path}?returnTo=${encodeURIComponent(target)}` : path;
}
export function clearAuthReturn() {
  sessionStorage.removeItem('pabs-client-return');
  sessionStorage.removeItem('pabs-auth-return');
}
export function appEntryDestination() {
  return localStorage.getItem('token') ? '/brief?entry=app' : authDestination('/register', '/brief?entry=app');
}
